import {
  HIDE_PRIVACY_POLICY_MODAL,
  HIDE_TERM_AND_CONDITION_MODAL,
  LOGIN,
  LOGIN_COMPLETE,
  LOG_OUT_COMPLETE,
  REGISTER_DRIVER_COMPLETE,
  SET_USER_CONTEXT,
  SHOW_PRIVACY_POLICY_MODAL,
  SHOW_TERM_AND_CONDITION_MODAL,
  SHOW_BUY_TERM_AND_CONDITION_MODAL,
  HIDE_BUY_TERM_AND_CONDITION_MODAL,
  UNSET_PATH,
  SHOW__ALL_BUY_PERMIT_LIST_MODAL,
  HIDE__ALL_BUY_PERMIT_LIST_MODAL,
  SHOW_CITATION_DETAILS_MODAL,
  HIDE_CITATION_DETAILS_MODAL,
  SHOW_VIEW_ORDERS_DETAILS_MODAL,
  HIDE_VIEW_ORDERS_DETAILS_MODAL,
  SET_CITATION_ENABLED,
  SET_CITATION_APPEALS_PREFERENCES,
  SET_FORGET_PASSWORD,
  SET_FORGET_USERNAME,
  SET_KEYCLOAK_USER,
  SHOW_MISSMATCH_DRIVER_ID_MODAL,
  HIDE_MISSMATCH_DRIVER_ID_MODAL,
} from "./action";

export const defaultState = {
  access_token: undefined,
  expires_in: undefined,
  refresh_expires_in: undefined,
  refresh_token: undefined,
  timestamp: undefined,
  token_type: undefined,
  session_state: undefined,
  registeredDriver: undefined,
  isLoading: false,
  loginError: null,
  userContext: ' ',
  citationAppleayDays:'',
  isAuthenticated: false,
  path: null,
  termAndConditionModalYN: false,
  buyTermAndConditionModalYN: false,
  allBuyperitListModal: false,
  citationDetailsModal: false,
  privacyPolicyModalYN: false,
  viewordersDetails: false,
  missMatchDriverId: false,
  citationEnabled: [],
  forgotePassword: '',
  forgotUserName: '',
  getKeycloakUsr: undefined
};

function LoginReducer(state = defaultState, action) {
  if (action.type === LOGIN_COMPLETE) {
    //
  }
  switch (action.type) {
    case LOGIN:
      return state;
    case LOGIN_COMPLETE:
      return {
        ...state,
        isAuthenticated: true,
        access_token: action.payload.access_token,
        expires_in: action.payload.expires_in,
        refresh_expires_in: action.payload.refresh_expires_in,
        refresh_token: action.payload.refresh_token,
        timestamp: action.payload.timestamp,
        token_type: action.payload.token_type,
        session_state: action.payload.session_state,
      };
    case SET_USER_CONTEXT:
      return {
        ...state,
        userContext: action.payload,
      };
    case UNSET_PATH:
      return {
        ...state,
        path: null,
      };
    case SHOW_TERM_AND_CONDITION_MODAL:
      return {
        ...state,
        termAndConditionModalYN: true,
      };
    case HIDE_TERM_AND_CONDITION_MODAL:
      return {
        ...state,
        termAndConditionModalYN: false,
      };
    case SHOW_BUY_TERM_AND_CONDITION_MODAL:
      return {
        ...state,
        buyTermAndConditionModalYN: true,
      };
    case HIDE_BUY_TERM_AND_CONDITION_MODAL:
      return {
        ...state,
        buyTermAndConditionModalYN: false,
      };
    case SHOW__ALL_BUY_PERMIT_LIST_MODAL:
      return {
        ...state,
        allBuyperitListModal: true,
      };
    case HIDE__ALL_BUY_PERMIT_LIST_MODAL:
      return {
        ...state,
        allBuyperitListModal: false,
      };
    case SHOW_CITATION_DETAILS_MODAL:
      return {
        ...state,
        citationDetailsModal: true,
      };
    case HIDE_CITATION_DETAILS_MODAL:
      return {
        ...state,
        citationDetailsModal: false,
      };
    case SHOW_VIEW_ORDERS_DETAILS_MODAL:
      return {
        ...state,
        viewordersDetails: true,
      };
    case HIDE_VIEW_ORDERS_DETAILS_MODAL:
      return {
        ...state,
        viewordersDetails: false,
      };

    case SHOW_PRIVACY_POLICY_MODAL:
      return {
        ...state,
        privacyPolicyModalYN: true,
      };
    case HIDE_PRIVACY_POLICY_MODAL:
      return {
        ...state,
        privacyPolicyModalYN: false,
      };
    case SHOW_MISSMATCH_DRIVER_ID_MODAL:
      return {
        ...state,
        missMatchDriverId: true,
      };
    case HIDE_MISSMATCH_DRIVER_ID_MODAL:
      return {
        ...state,
        missMatchDriverId: false,
      };
    case REGISTER_DRIVER_COMPLETE:
      return {
        ...state,
        registeredDriver: action.payload,
      };
    case SET_FORGET_PASSWORD:
      return {
        ...state,
        forgotePassword: action.payload,
      };
    case SET_FORGET_USERNAME:
      return {
        ...state,
        forgotUserName:action.payload
      };
    case SET_CITATION_ENABLED:
      return {
        ...state,
        citationEnabled: action.payload,
      };
    case SET_CITATION_APPEALS_PREFERENCES:
      return {
        ...state,
        citationAppleayDays: action.payload,
      };
    case SET_KEYCLOAK_USER:
      return{
        ...state,
        getKeycloakUsr:action.payload
      }
    case LOG_OUT_COMPLETE:
      return { ...defaultState };
    default:
      return state;
  }
}

export default LoginReducer;
